module.exports = __webpack_public_path__ + "img/gray-white-transition-clean.6849fa95.png";